import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MdViewerProps {
  content: string;
}
export const MdViewer = ({ content }: MdViewerProps) => {
  return (
    <div className="markdown-box">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p({ children }) {
            // 分割换行，插入 br
            const arr = React.Children.toArray(children)
              .flatMap((child, childIndex) => {
                if (typeof child === 'string') {
                  return child.split('\n').flatMap((item, idx, list) =>
                    idx === list.length - 1 ? item : [item, <br key={`p-${childIndex}-${idx}`} />]
                  );
                }
                return child;
              });
            return <p>{arr}</p>;
          },
          li({ children, ...props }) {
            // 列表内换行同样处理
            const arr = React.Children.toArray(children)
              .flatMap((child, childIndex) => {
                if (typeof child === 'string') {
                  return child.split('\n').flatMap((item, idx, list) =>
                    idx === list.length - 1 ? item : [item, <br key={`li-${childIndex}-${idx}`} />]
                  );
                }
                return child;
              });
            return <li {...props}>{arr}</li>;
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};